import { render } from "./statistical.vue?vue&type=template&id=0b22e40e&scoped=true&ts=true"
import script from "./statistical.vue?vue&type=script&lang=ts"
export * from "./statistical.vue?vue&type=script&lang=ts"

import "./statistical.vue?vue&type=style&index=0&id=0b22e40e&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b22e40e"]])

export default __exports__